
// Base URL - empty in development (uses proxy), full URL in production
const BASE_URL = process.env.NODE_ENV === 'production'
    ? "http://billing.futurefitnessgymnellore.com:8081"
    : "";

const BRANCH_MAPPING = {
    "Stonehousepet, Nellore": 1,
    "Harinathpuram, Nellore": 2,
    "Vanamthopu Center, Nellore": 3,
    "Current Office Center, Nellore": 4,
    "Vedayapalem, Nellore": 5,
    "BV Nagar, Nellore": 6,
    "Dhanalakshmi Puram, Nellore": 7,
    "Dhanalakshmi, Nellore": 7, // Handle potential variation
};

export const addEnquiry = async (enquiryData) => {
    try {
        const branchId = BRANCH_MAPPING[enquiryData.location] || 1; // Default to 1 if not found

        const payload = {
            name: enquiryData.fullName || "Optional Name",
            branchId: branchId,
            phoneNumber: enquiryData.phone,
            email: enquiryData.email || "optional@example.com",
            remarks: null,
        };

        const url = `${BASE_URL}/api/enquiry/add`;
        console.log("🔵 Calling API:", url);
        console.log("📦 Payload:", payload);

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        console.log("📡 Response status:", response.status);
        console.log("📡 Response headers:", response.headers);

        // Get response text first
        const responseText = await response.text();
        console.log("📄 Response text:", responseText);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}, response: ${responseText}`);
        }

        // Try to parse as JSON
        try {
            const data = JSON.parse(responseText);
            console.log("✅ Parsed JSON:", data);
            return data;
        } catch (parseError) {
            console.error("❌ Failed to parse JSON. Response was:", responseText);
            throw new Error(`Invalid JSON response: ${responseText.substring(0, 100)}...`);
        }
    } catch (error) {
        console.error("❌ Error adding enquiry:", error);
        throw error;
    }
};
